import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from '@mui/material';
import './SeasonalOutlook.css';

const InfoBox = ({ icon, label, value }) => (
  <Box className="info-box" display="flex" alignItems="flex-start" gap={1}>
    <Box>{icon}</Box>
    <Box textAlign={'left'}>
      <Typography fontSize="14px">{label}</Typography>
      <Typography fontWeight="bold">{value}</Typography>
    </Box>
  </Box>
);

const SeasonalOutlook = () => {
  return (
    <div>
      <Typography
        fontSize="14px"
        color="rgba(8, 128, 234, 1)"
        mb={2}
        textAlign="left"
        fontWeight={600}
      >
        Forecasted Losses
      </Typography>

      <Box display="flex" gap={4} marginBottom={4}>
        <InfoBox
          icon={<img src="/expectedloss.png" alt="Expected Loss" width={40} height={40} />}
          label="Expected Loss"
          value="₹45/qtl"
        />
        <InfoBox
          icon={<img src="/losspercent.png" alt="Loss Percentage" width={40} height={40} />}
          label="Loss Percentage"
          value="12%"
        />
      </Box>

      <Typography
        fontSize="14px"
        color="rgba(8, 128, 234, 1)"
        mb={2}
        textAlign="left"
        fontWeight={600}
      >
        Forecasted Scenarios
      </Typography>
<Table sx={{ borderCollapse: 'separate', borderSpacing: '0 8px', width: '100%' }}>
  <TableHead>
    <TableRow sx={{ backgroundColor: 'rgba(237, 246, 255, 1)'}}>
      <TableCell sx={{ border: 'none', fontWeight: 600, padding: '8px 16px' }}>Case</TableCell>
      <TableCell sx={{ border: 'none', fontWeight: 600 , padding: '8px 16px' }}>Key Factors</TableCell>
      <TableCell sx={{ border: 'none', fontWeight: 600, padding: '8px 16px'  }}>Probability</TableCell>
      <TableCell sx={{ border: 'none', fontWeight: 600 , padding: '8px 16px' }}>Loss</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    <TableRow sx={{ 
      backgroundColor: 'rgba(251, 254, 252, 0.99)', 
      fontSize:'12px',
    }}>
      <TableCell sx={{ 
        border: '1px solid rgba(180, 223, 196, 1)', 
        borderRight: 'none',
        fontSize: "12px" 
      }}>
        <Box display="flex" alignItems="center" gap={1}>
          <img src="/case1.png" alt="Case 1" width={25} height={25} />
          <Box marginLeft={'5px'}>
            Bullish Scenario - Market Price Increases
            <Box sx={{ fontSize: '10px', color: 'rgba(4, 4, 0, 0.91)', fontWeight:300 }}>(Post Harvest)</Box>
          </Box>
        </Box>
      </TableCell>
      <TableCell sx={{ 
        border: '1px solid rgba(180, 223, 196, 1)', 
        borderRight: 'none',
        borderLeft: 'none',
        fontSize: "12px" 
      }}>
        <ul style={{ paddingLeft: '16px', margin: 0 }}>
          <li>Higher than expected ethanol demand</li>
        </ul>
      </TableCell>
      <TableCell sx={{ 
        border: '1px solid rgba(180, 223, 196, 1)', 
        borderRight: 'none',
        borderLeft: 'none',
        fontSize:"12px",
        fontWeight:600 
      }}>75%</TableCell>
      <TableCell sx={{ 
        border: '1px solid rgba(180, 223, 196, 1)', 
        borderLeft: 'none',
        fontSize:"12px",
        fontWeight:600 
      }}>0</TableCell>
    </TableRow>

    <TableRow sx={{ 
      backgroundColor: 'rgba(255, 252, 254, 1)', 
      borderBottom: 'none'
    }}>
      <TableCell colSpan={4} sx={{ 
        border: '1px solid rgba(243, 198, 226, 1)',
        fontSize:'12px',
        padding: 0
      }}>
        {/* Main bearish scenario row */}
        <Box sx={{ 
          display: 'flex', 
          padding: '12px',
          borderBottom: 'none'
        }}>
          <Box sx={{ flex: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
            <img src="/case2.png" alt="Case 2" width={25} height={25} />
            <Box marginLeft={'5px'}>
              Bearish Scenario - Market Price Decreases
              <Box sx={{ fontSize: '10px', color: 'rgba(4, 4, 0, 0.91)',fontWeight:300  }}>(Post Harvest)</Box>
            </Box>
          </Box>
          <Box sx={{ flex: 2.3 }}>
            <ul style={{ paddingLeft: '16px', margin: 0 }}>
              <li>Removal of import duty for US Maize imports</li>
              <li>Increased supply to Ethanol from other competitive grains</li>
            </ul>
          </Box>
          <Box sx={{ flex: 1 }}></Box>
          <Box sx={{ flex: 1 }}></Box>
        </Box>
        
        {/* Sub-rows without horizontal borders */}
        <Box sx={{ padding: '12px', paddingTop: 0 }}>
          <Box display="flex" flexDirection="column" gap={1}>
            {[
              {
                caseText: 'Post-Harvest prices fall by 5%',
                probability: '15%',
                loss: '₹112.5/qtl',
              },
              {
                caseText: 'Post-Harvest prices fall by 10%',
                probability: '5%',
                loss: '₹225/qtl',
              },
              {
                caseText: 'Post-Harvest prices fall by 15%',
                probability: '5%',
                loss: '₹337.5/qtl',
              },
            ].map((row, index) => (
              <Box
                key={index}
                display="flex"
                justifyContent="space-between"
                textAlign="right"
                marginLeft={5}
                p={1}
                px={2}
                sx={{
                  backgroundColor: 'rgba(249, 249, 248, 1)',
                  border: '1px solid rgba(200, 199, 193, 1)',
                  borderRadius: '4px',
                }}
              >
                <Box textAlign="center" flex={1.5}>{row.caseText}</Box>
                <Box flex={0}> </Box>
                <Box flex={2} fontWeight={600}>{row.probability}</Box>
                <Box flex={0.5} fontWeight={600}>{row.loss}</Box>
              </Box>
            ))}
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  </TableBody>
</Table>
      
    </div>
  );
};

export default SeasonalOutlook;
